export default __webpack_public_path__ + "static/media/G0120.34I-29370_-21492_0-RS.1709298180000.80fee940.jpg";